import axios from 'axios';
import { PERSISTOR_URL } from './urls.mjs';
import { Topics } from '../util/Events/schema';

/**
 * Queries persisted events for a given Kafka topic across the supplied time
 * range. The persistor returns events for every asset in the project window;
 * any per-asset filtering is the caller's responsibility.
 *
 * Generic over `Topics` so that, for example, `topic: 'asset.coordinates'`
 * yields `{ data: AssetCoordinates }[]` (each persistor record wraps its
 * payload under a `data` field).
 */
export const queryEvents = async <K extends keyof Topics>({
  clientId,
  projectId,
  topic,
  fromUnixTs,
  toUnixTs,
  Authorization,
  signal,
}: {
  clientId: string;
  projectId: string;
  topic: K;
  fromUnixTs: number;
  toUnixTs: number;
  Authorization: string;
  signal?: AbortSignal;
}) => {
  return (
    await axios.get<{ data: Topics[K] }[]>(
      `${PERSISTOR_URL}/${clientId}/${projectId}/query/${fromUnixTs}/${toUnixTs}?topic=${topic}`,
      { headers: { Authorization }, signal },
    )
  ).data;
};
